/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_N8n_AnswerInputs */

const en_faq_n8n_answer = /** @type {(inputs: Faq_N8n_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. We build AI workflow automation in n8n when a visual, self-hostable workflow is the right fit, and in custom code when the process needs more control. Either way, you receive documented workflows, clear approval rules and a named owner for the exceptions.`)
};

const lv_faq_n8n_answer = /** @type {(inputs: Faq_N8n_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jā. Mēs veidojam AI darba plūsmu automatizāciju n8n, ja procesam der vizuāla, pašu mitināma darba plūsma, un pielāgotā kodā, ja vajadzīga lielāka kontrole. Abos gadījumos saņemat dokumentētas darba plūsmas, skaidrus apstiprināšanas noteikumus un atbildīgo par izņēmumiem.`)
};

/**
* | output |
* | --- |
* | "Yes. We build AI workflow automation in n8n when a visual, self-hostable workflow is the right fit, and in custom code when the process needs more control. E..." |
*
* @param {Faq_N8n_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_n8n_answer = /** @type {((inputs?: Faq_N8n_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_N8n_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_n8n_answer(inputs)
	return en_faq_n8n_answer(inputs)
});